import clsx from "classnames";
import classes from "./styles.module.scss";
import Title from "@/ui/Title";
import HeaderTitle from "../HeaderTitle";
export default function FeaturedContent({ link, className }) {

  return (
    <div className={clsx(className, classes.featured)}>
      <div className={classes.highlight}>
         <HeaderTitle title={'featured content'} color="#B2C2BA"  fontSize={'28px'} lineHeight={'34px'}/>   
      </div>
      <video width="640" height="360" controls>
        <source src={link} type="video/mp4" />
      </video>
    </div>
  );
}

FeaturedContent.defaultProps = {
  className: "",
};
